import React from 'react'
import { SectionHeader, SectionWrap, ButtonSecoundry } from '../../Components';
import FieldsShort from '../FieldsShort/FieldsShort';
import './Conflict.css';
import { useTranslation } from 'react-i18next';

function Conflict() {
  const { t, i18n } = useTranslation();
  
  return (
    <>
    <div className='fieldsPageContainer'>
        <div className='headPage conflict'>
        </div>
        <div className='containerNew'>
            <SectionWrap>
            <SectionHeader title={t('fieldsShort3')} disc={t('fieldsPageSpan')} />
            <div className='fieldInfo'>
                <p>{t('fieldsPage3p1')}</p>
                <span>{t('fieldsPage3span1')}</span>
                <p>{t('fieldsPage3p2')}</p>
                <span>{t('fieldsPage3span2')}</span>
                <p>{t('fieldsPage3p3')}</p>
                <span>{t('fieldsPage3span3')}</span>
                <ul className='listProperty'>
                    <li>{t('fieldsPage3Li1')}</li>
                    <li>{t('fieldsPage3Li2')}</li>
                    <li>{t('fieldsPage3Li3')}</li>
                    <li>{t('fieldsPage3Li4')}</li>
                    <li>{t('fieldsPage3Li5')}</li>
                </ul>
                <span>{t('fieldsPage3span4')}</span>
                <p>{t('fieldsPage3p4')}</p>
                <p>{t('fieldsPage3p5')}</p>
            </div>
            <ButtonSecoundry className='askBtnFields' href='/askConsults'>{t('askYourConsult')}</ButtonSecoundry>
        </SectionWrap>
        </div>
        <FieldsShort />
    </div>
    </>
  )
}

export default Conflict